function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".AddImage-1{fill:#37beb7;stroke:#ffbe54;stroke-miterlimit:10;}.AddImage-2{fill:#010002;}"));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "AddImage-1",
  cx: 11.25,
  cy: 17.81,
  r: 2.63
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "AddImage-2",
  d: "M22.5,13.18V5.23L17.26,0H0V30H22.5v-.06a8.43,8.43,0,0,0,0-16.76ZM16.87,2.26l3.37,3.36H16.87Zm-15,25.86V1.87H15V7.5h5.62v5.68a8.46,8.46,0,0,0-2.3.59,2.18,2.18,0,0,0-1.45-.65H15l-1.88-1.87H9.37L7.5,13.12H5.62A1.83,1.83,0,0,0,3.75,15v5.62A1.83,1.83,0,0,0,5.62,22.5h7.56a8.41,8.41,0,0,0,3.08,5.62Zm12.18-10.4a8.92,8.92,0,0,0-.71,2,2.77,2.77,0,0,1-2.09.95,2.81,2.81,0,1,1,2.8-2.9Zm7.51,10.4a6.56,6.56,0,1,1,6.56-6.56A6.56,6.56,0,0,1,21.56,28.12Z"
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  className: "AddImage-2",
  points: "17.58 22.89 20.24 22.89 20.24 25.54 22.89 25.54 22.89 22.89 25.54 22.89 25.54 20.24 22.89 20.24 22.89 17.58 20.24 17.58 20.24 20.24 17.58 20.24 17.58 22.89"
});

var SvgAddImage = function SvgAddImage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "AddImage",
    "data-name": "AddImage 1",
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddImage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AddImage.01677005.svg";
export { ForwardRef as ReactComponent };